import { render, staticRenderFns } from "./RemessaHome.vue?vue&type=template&id=20892b66"
import script from "./RemessaHome.vue?vue&type=script&lang=js"
export * from "./RemessaHome.vue?vue&type=script&lang=js"
import style0 from "./RemessaHome.vue?vue&type=style&index=0&id=20892b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports